var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-menu',{attrs:{"items":_vm.menuItems,"icon":"mdi-dots-horizontal","iconColor":"$blue-color"},on:{"selected":_vm.selected,"input":_vm.input}})}
var staticRenderFns = []

export { render, staticRenderFns }